import { render, staticRenderFns } from "./TemplateEditModal.vue?vue&type=template&id=1ed22b82&"
import script from "./TemplateEditModal.vue?vue&type=script&lang=js&"
export * from "./TemplateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports